import { render, staticRenderFns } from "./Company-edit.vue?vue&type=template&id=5c0de742&"
import script from "./Company-edit.vue?vue&type=script&lang=js&"
export * from "./Company-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports